import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_4: FaireProductEntity = {
  token: "ai_bulk_4",
  type: "product",
  name: "Together Coasters",
  brandName: "Ai Bulk Brand",
  imageUrl: "",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
